export default __webpack_public_path__ + "static/about1-5e3a09ee56c0c5cab2b072197e1221dc.jpg";